import { useSearchParams } from 'react-router-dom';
import { HypoEmptyState } from './hypo-empty';
import { HypoglycemiaList } from './hypoglycemia-list';
import { NumberHypoEventPart } from './hypo-chart-container';
import { HypoglycemiaReadings } from './hypoglycemia-readings';
import { useHypo } from 'modules/report/hooks/useHypo';
import { MainAccordion } from 'modules/components/common';
import styled from 'styled-components';
import { Dropdown } from '../dropdown/dropdown';

const deStructureHypoChart = (data) => {
  const result = [];
  result.push({ hours: 'Hours', type: 'chart-label' });
  data?.map((item) =>
    result.push({
      hours: `${item.from}-${item.to}`,
      allCount: item?.allCount,
      level2Count: item?.level2Count
    })
  );
  return result;
};
const deStructureHypoList = (data) => {
  return {
    total: data.level1Count + data.level2Count,
    level1: data.level1Count,
    level2: data.level2Count,
    nocturnal: data.nocturnalCount
  };
};
export const HypoContainer = ({
  daysAgo,
  customDateData,
  customDateListLoading,
  customDateListData,
  disableGetListDataBtn,
  getListData
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const patientId = searchParams.get('patientId');

  const hypoes = useHypo({ patientId, daysAgo });
  const data = typeof daysAgo === 'number' ? hypoes?.data : customDateData;

  const HypoglycemiaListData = data ? deStructureHypoList(data) : {};
  const HypoglycemiaChartData = data
    ? deStructureHypoChart(data?.hourlies)
    : [];
  const emptyData =
    data?.level1Count + data?.level2Count + data?.nocturnalCount === 0;

  const chart = (
    <>
      {emptyData ? (
        <div style={{ marginBottom: '20px' }}>
          <HypoEmptyState />
        </div>
      ) : (
        <>
          <HypoglycemiaList
            HypoglycemiaListData={HypoglycemiaListData}
            patientId={patientId}
          />
          <NumberHypoEventPart
            HypoglycemiaChartData={HypoglycemiaChartData}
            patientId={patientId}
          />
          <HypoglycemiaReadings
            getCustomDateList={getListData}
            disableGetListDataBtn={disableGetListDataBtn}
            patientId={patientId}
            daysAgo={daysAgo}
            customDateListLoading={customDateListLoading}
            customDateListData={customDateListData}
          />
        </>
      )}
    </>
  );

  return (
    <StyledHypoContainer>
      <div className="mobile-view">
        <MainAccordion
          open={'panel1'}
          header="Risk analysis"
          subHeaderHypo={daysAgo}
        >
          {chart}
          <Dropdown>
            <TextAccordion>
              This section puts Hypoglycemia events in focus to help you better
              protect your patient from future hypoglycemia emergencies and the
              subsequent complications. With the help of the information
              provided in this section you can easily assess if the current
              treatment regimen or the patient's lifestyle is putting the
              patient at risk, and take measures to modify the diabetes
              management plan.
            </TextAccordion>
          </Dropdown>
        </MainAccordion>
      </div>
      <div className="web-view">
        <p className="hypo-title-bold">Risk analysis</p>
        <p className="hypo-title">
          Analysing Readings From <span>{daysAgo} days ago</span>
        </p>

        {chart}
      </div>
    </StyledHypoContainer>
  );
};

const TextAccordion = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  direction: ltr;
  color: #4e4e4e;
  margin-bottom: 15px;
`;

export const StyledHypoContainer = styled.div`
  width: 100%;
  .hypo-title-bold {
    text-align: center;
    color: #753cbe;
    font-size: 28px;
    font-family: 'dana-bold';
    line-height: 43px;
    padding-bottom: 32px;
  }
  .hypo-title {
    margin: auto;
    width: max-content;
    text-align: center;
    color: #753cbe;
    font-size: 24px;
    border-bottom: 2px solid #d8d8d8;
    padding-bottom: 20px;
    span {
      color: #d81d5d;
      font-family: 'dana-bold';
    }
  }
  .web-view {
    display: none;
  }
  @media screen and (min-width: 1024px) {
    .web-view {
      background: #ffffff;
      padding-top: 89px;
      display: block;
    }
    .mobile-view {
      display: none;
    }
  }
`;
